<template>
  <div>
    <InputMoney
        v-model="value_cash"
        label="Preço"
        name="value_cash"
        :errors="errors"
    />
  </div>
</template>

<script>
import InputMoney from "../inputs/InputMoney.vue";

export default {
  name: "AVista",
  components: {InputMoney},
  data() {
    return {
      errors: [],
      value_cash: null,
    }
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/carrefour/rules/AVista.vue